import hellojs from '../../vendor/hello.js'

export default function(type) {
  return hellojs
    // Initialize Driver instance
    .init({
      dropbox: type === 'full'
        ? window.Drupal.settings.INTEGRATIONS_DROPBOX_FULL_APP_ID  // Use Full Access App
        : window.Drupal.settings.INTEGRATIONS_DROPBOX_APP_ID       // Use AppFolder App
    }, {
      redirect_uri: 'https://app.courtdrive.com/rpc/static/hello.js/redirect.html',
      oauth_proxy: `${window.location.origin}/rpc/integrations/oauth_proxy`,
      response_type: 'code',
    })('dropbox'); // spawn an instance of the driver that one can call .login() on
}



// WEBPACK FOOTER //
// ./src/Integrations/connections/DropboxAuthenticator.jsx